import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const clinicaGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Aguardar carregamento do usuário
  await authService.loadUser();

  const user = authService.currentUser();
  
  console.log('[ClinicaGuard] Checking access for:', user?.email);
  console.log('[ClinicaGuard] User tipo:', user?.tipo);
  console.log('[ClinicaGuard] Expected tipo: clinica');

  if (!user) {
    console.log('[ClinicaGuard] No user found, redirecting to login');
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }

  if (user.tipo !== 'clinica') {
    console.log('[ClinicaGuard] User is not clinica, redirecting to home');
    console.log('[ClinicaGuard] User tipo is:', user.tipo);
    router.navigate(['/']);
    return false;
  }

  console.log('[ClinicaGuard] Access granted');
  return true;
};
